import { forwardRef, useEffect } from 'react';
import { Stack, Button, Skeleton } from '@mui/material';
import { useStoreByName } from '@web/hooks/use-stores.hooks';
import { observer } from 'mobx-react-lite';
import TextElement from '../text/TextElement';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useTranslation } from 'react-i18next';
import { toJS } from 'mobx';

const PreviewTextArea = forwardRef<HTMLDivElement>((props, ref) => {
  const { t, i18n } = useTranslation();
  const { selectedBook, selectedTextEntity, goNextOrPrevEntity, isLoading } = useStoreByName('booksStore');

  const renderLoader = () => (
    <>
      <Skeleton height={40} width={'100%'} />
      <Skeleton height={40} width={'100%'} />
      <Skeleton height={40} width={'100%'} />
      <Skeleton height={40} width={'100%'} />
      <Skeleton height={40} width={'100%'} />
      <Skeleton height={40} width={'100%'} />
      <Skeleton height={40} width={'100%'} />
    </>
  );

  useEffect(() => {
    selectedTextEntity && console.log({ selectedTextEntity: toJS(selectedTextEntity) });
  }, [selectedTextEntity]);

  // גלילה חזרה לתחילת הטקסט כאשר משתנה הקטע הנבחר
  useEffect(() => {
    if (selectedTextEntity) {
      setTimeout(() => {
        const originalTextElement = document.querySelector('.original-text.text-wrapper');
        if (originalTextElement) {
          originalTextElement.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 100);
    }
  }, [selectedTextEntity]);

  return (
      <div className="original-text-area">
        <Stack
          className="navigation"
          spacing={5}
          direction="row"
          style={{ marginBottom: 12, justifyContent: 'space-between' }}
        >
          <>
            <Button sx={{ margin: '0 !important' }} onClick={() => goNextOrPrevEntity(false)} variant="text" startIcon={<KeyboardArrowRightIcon />}>
              {selectedBook?.name_en === 'Mishna' ? t('previousMishna') : t('previousPassage')}
            </Button>
            <Button sx={{ margin: '0 !important' }} onClick={() => goNextOrPrevEntity(true)} variant="text" endIcon={<KeyboardArrowLeftIcon />}>
              {selectedBook?.name_en === 'Mishna' ? t('nextMishna') : t('nextPassage')}
            </Button>
          </>
        </Stack>

        <div
          className="text-container"
          ref={ref}
          role="region"
          tabIndex={0}
          aria-label="הטקסט לקריאה"
        >
          {isLoading && renderLoader()}
          {!isLoading && selectedTextEntity && (
            <TextElement
              mode="preview"
              fontClassName={
                selectedBook?.name_en?.includes('Siddur') ? 'Drogowskaz' :
                selectedBook?.name_en === 'Mishna' ? 'OpenFrank' : 'Ezra'
              }
              showArrowIndicator={false}
              preventCopyPaste={true}
            />
          )}
        </div>
      </div>
  );
});

export default observer(PreviewTextArea);
